import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../utils/common/common";
import { IConnectionDetails, IFeedbackAccordionSettings } from "./types";
import { PasswordFieldWithVisibilityToggle } from "../common/PasswordFieldWithVisibilityToggle";
import RequiredFieldMarker from "../../utils/common/RequiredFieldMarker";

interface IConnectionDetailsProps {
  name?: string;
  accordionSettings: IFeedbackAccordionSettings;
  handleAccordionChange: (name: string) => void;
  connectionDetails: IConnectionDetails;
  setConnectionDetails: (newState: any) => void;
}

const ConnectionDetails = ({
  name = "",
  accordionSettings,
  handleAccordionChange,
  connectionDetails,
  setConnectionDetails,
}: IConnectionDetailsProps) => {
  const handleCheckboxChange = (e: any) => {
    const { name: controlName, checked } = e.target;
    setConnectionDetails((prevState: IConnectionDetails) => ({
      ...prevState,
      [controlName]: checked,
    }));
  };

  const handleInputChange = (e: any) => {
    const { name: controlName } = e.target;
    let { value } = e.target;
    if (controlName === "port" && value !== "") {
      value = parseInt(value);
    }
    setConnectionDetails((prevState: IConnectionDetails) => {
      return {
        ...prevState,
        [controlName]: value,
      };
    });
  };

  return (
    <Box className="accordion-wrap" mt="16px">
      <Accordion
        expanded={accordionSettings["connectionDetails"]}
        onChange={() => handleAccordionChange("connectionDetails")}
      >
        <AccordionSummary aria-controls={"panel1-content"} id={"panel1-header"}>
          <Grid container className="acc-prod-icon">
            <Grid item className="acc-prod-icon">
              Connection details
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          {/* <Grid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="useSecureConnection"
                    checked={connectionDetails.useSecureConnection}
                    onChange={handleCheckboxChange}
                    color="primary"
                  />
                }
                label="Use secure connection (SSL/TLS)"
              />
            </Box>
          </Grid> */}
          <Grid item xs={12} mt={2}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Email provider
                <RequiredFieldMarker />
              </InputLabel>
              <Select
                name="emailProvider"
                value={connectionDetails.emailProvider}
                label="Email Provider"
                onChange={handleInputChange}
              >
                <MenuItem value="Google">Gmail</MenuItem>
                <MenuItem value="Microsoft" disabled>
                  Microsoft Outlook/365
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} mt={2}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Authentication mode
                <RequiredFieldMarker />
              </InputLabel>
              <Select
                name="authenticationMode"
                value={connectionDetails.authenticationMode}
                label="Authentication mode"
                onChange={handleInputChange}
              >
                {/* <MenuItem value="OAuth2">OAuth2 - Client credentials</MenuItem> */}
                <MenuItem value="oauth2ServiceAccount">
                  OAuth2 - Service Account credentials
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <Grid item xs={12} sx={{ mt: 2 }}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Host
                {connectionDetails.authenticationMode !=
                  "oauth2ServiceAccount" && (
                  <div
                    style={{
                      display: "inline-block",
                      color: "red",
                      marginLeft: "1px",
                    }}
                  >
                    *
                  </div>
                )}
              </InputLabel>
              <OutlinedInput
                type="text"
                value={connectionDetails.host}
                onChange={handleInputChange}
                name="host"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Port
                {connectionDetails.authenticationMode !=
                  "oauth2ServiceAccount" && (
                  <div
                    style={{
                      display: "inline-block",
                      color: "red",
                      marginLeft: "1px",
                    }}
                  >
                    *
                  </div>
                )}
              </InputLabel>
              <OutlinedInput
                type="number"
                value={connectionDetails.port}
                onChange={handleInputChange}
                name="port"
              />
            </FormControl>
          </Grid> */}
          {connectionDetails.authenticationMode === "basic" && (
            <>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Username
                    <RequiredFieldMarker />
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={connectionDetails.username}
                    onChange={handleInputChange}
                    name="username"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <PasswordFieldWithVisibilityToggle
                  placeHolder="Password"
                  value={connectionDetails.password}
                  name="password"
                  fieldKey={`${name}-password`}
                  onChange={handleInputChange}
                  isMandatory={true}
                />
              </Grid>
            </>
          )}
          {connectionDetails.authenticationMode == "OAuth2" && (
            <>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Client ID
                    <RequiredFieldMarker />
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={connectionDetails.clientID}
                    onChange={handleInputChange}
                    name="clientID"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Tenant ID
                    <RequiredFieldMarker />
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={connectionDetails.tenantID}
                    onChange={handleInputChange}
                    name="tenantID"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Username
                    <RequiredFieldMarker />
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={connectionDetails.OAuthUsername}
                    onChange={handleInputChange}
                    name="OAuthUsername"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <PasswordFieldWithVisibilityToggle
                  placeHolder="Client secret"
                  value={connectionDetails.clientSecret}
                  name="clientSecret"
                  fieldKey={`${name}-clientSecret`}
                  onChange={handleInputChange}
                  isMandatory={true}
                />
              </Grid>
            </>
          )}
          {connectionDetails.authenticationMode == "oauth2ServiceAccount" && (
            <>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <PasswordFieldWithVisibilityToggle
                  placeHolder="Service Account Credentials"
                  value={connectionDetails.mailServiceAccount || ""}
                  name="mailServiceAccount"
                  fieldKey={`${name}-mailServiceAccount`}
                  onChange={handleInputChange}
                  isMandatory={true}
                />
              </Grid>
            </>
          )}
          <Grid item xs={12} sx={{ mt: 2 }}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Email address
                <RequiredFieldMarker />
              </InputLabel>
              <OutlinedInput
                type="text"
                value={connectionDetails.emailAddress}
                onChange={handleInputChange}
                name="emailAddress"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ mt: 2 }}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Folder name from where emails should be picked up
              </InputLabel>
              <OutlinedInput
                type="text"
                value={connectionDetails.folderName}
                onChange={handleInputChange}
                name="folderName"
              />
            </FormControl>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ConnectionDetails;
